<div [hidden]="consulta" class="evaluacion">
  <div class="row">
      <div class="col-lg-12" style="padding: 0px;">
          <section class="widget evaluacion__preguntas scroll-container">
              <div>
                  <div class="row margen">
                      <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                          <div class="row">
                            <div class="col-3" *ngIf="entidad.asignacionacuerdoresponsableid">
                              <dropdownCustom titulo="Puesto"
                              [opciones]="listapuesto"
                              [(ngModel)]="puesto"
                              [valorName]="'puestosubid'"
                              [displayValor]="'puestosub'"
                              [buscar]="false"
                              (ngModelChange)="buscardatos($event)"
                              ></dropdownCustom>
                            </div>
                              <div class="col-3">
                                  <multiSelect [titulo]="'Talleres'" valorName="tallerextracurricularid"
                                  displayValor="taller" propiedad="tallerextracurricularid"
                                  [opciones]="listataller" [(ngModel)]="taller" (ngModelChange)="getgrupo($event)"
                                  ></multiSelect>
                              </div>
                              <div class="col-3">
                                  <multiSelect [titulo]="'Grupos'" valorName="grupoid"
                                  displayValor="grupo" propiedad="grupoid"
                                  [opciones]="listagrupos" [(ngModel)]="grupo"
                                  ></multiSelect>
                              </div>
                              <div class="col-3">
                                  <button class="boton botonSM filledBlanco" (click)="consultar()">Consultar</button>
                              </div>
                          </div>
                      </div>
                      <div class="col-lg-6 col-md-6">
                          <div class="row">
                              <div class="col-6">
                                  <checkBoxCustom [titulo]="'Agrupar por competencia'" [alineacion]="1" [disabled]="false"
                                  [(ngModel)]="buscarcompetencia" (ngModelChange)="VerPorCompetencia($event)"></checkBoxCustom>
                              </div>
                              <div class="col-6">
                                  <checkBoxCustom [titulo]="'Agrupar por criterio'" [alineacion]="1" [disabled]="false"
                                  [(ngModel)]="buscarcriterio" (ngModelChange)="VerPorCriterio($event)"></checkBoxCustom>
                              </div>
                          </div>
                      </div>
                  </div>
                  <!-- datos -->
                  <div>
                      <div *ngFor="let competencia of listageneral; index as index">
                          <div class="col-12 evaluacion__preguntas__competencia" style="box-shadow: 0 0 10px -6px {{competencia.color}}; background: {{competencia.color}}">
                              <div class="{{competencia.colortext}} evaluacion__preguntas__competencia__titulo">
                                  <span>{{competencia.nombrecompetencia}}</span>
                              </div>
                          </div>
                          <div *ngIf="competencia.criterios; else blockcompetencia">
                              <div *ngFor="let criterio of competencia.criterios; index as index" >

                                  <div class="evaluacion__preguntas__criterio">
                                      <i class="fa fa-circle" aria-hidden="true" style="color: {{competencia.color}}"></i>
                                      <span class="evaluacion__preguntas__criterio__texto">{{criterio.nombrecriterio}}</span>
                                  </div>
                                  <div *ngIf="criterio.preguntas; else blockcriterio">
                                      <div *ngFor="let pregunta of criterio.preguntas; index as index">
                                          <div class="evaluacion__preguntas__pregunta">
                                              <span>{{index+ 1}}.-{{pregunta.nombrepregunta}}</span>
                                          </div>
                                          <div *ngFor="let escala of pregunta.escalaevaluacion; index as index">

                                              <pivotcomponente
                                              [info]="escala"
                                              >
                                              </pivotcomponente>
                                          </div>
                                      </div>
                                  </div>
                                  <div *ngIf="criterio.preguntasabiertas">
                                    <div *ngFor="let abierta of criterio.preguntasabiertas; index as index">
                                      <div class="evaluacion__preguntas__pregunta">
                                        <span>{{index+ 1}}.-{{abierta.nombrepregunta}}</span>
                                      </div>
                                      <acordioncomponente [info]="abierta.inforespuesta"></acordioncomponente>

                                    </div>
                                  </div>
                                  <ng-template #blockcriterio>
                                      <div *ngFor="let escala of criterio.escalaevaluacion; index as index">
                                          <pivotcomponente
                                          [info]="escala"
                                          >
                                          </pivotcomponente>
                                      </div>
                                      <div *ngIf="criterio.criteriopreguntasabiertas.length > 0">
                                        <acordioncomponente [info]="criterio.criteriopreguntasabiertas"></acordioncomponente>
                                      </div>
                                  </ng-template>
                              </div>
                          </div>
                          <ng-template #blockcompetencia>
                              <div *ngFor="let escala of competencia.escalaevaluacion; index as index">
                                  <pivotcomponente
                                  [info]="escala"
                                  >
                                  </pivotcomponente>
                              </div>
                              <div *ngIf="competencia.competenciapreguntaabierta.length > 0">
                                <acordioncomponente [info]="competencia.competenciapreguntaabierta"></acordioncomponente>

                              </div>
                          </ng-template>
                      </div>
                      <div *ngIf="listaobservacion.length > 0">
                          <h3>Observaciones o comentarios generales</h3>
                          <div *ngFor="let observacion of listaobservacion; index as index">
                              <h5>{{index+1}}.- {{observacion.observaciones}}</h5>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
      </div>
  </div>
</div>
